import userTieIcon from "../../../assets/images/userTieIcon.svg";
import { customAttrDisplay } from "../../PointOfSale/Core/modals/customAttributes/displayValue";
import Offers from "../../../assets/images/promoTag.svg";
import DeleteProduct from "../../../assets/images/delete1.svg";
import NotesImage from "../../../assets/images/notes.svg";
import userAddIcon from "../../../assets/images/userAddIcon.svg";

/**
 * Returns the columns array for the SM cart Table.
 *
 * @param {object} params
 * @param {object} params.posConfig
 * @param {object} params.cart
 * @param {number} params.pricePrecision
 * @param {Array}  params.currenciesList
 * @param {object} params.selectedProductInCart
 * @param {function} params.selectProductInCart
 * @param {Array}  params.selectedRowKeys
 * @param {function} params.setShowPaymentMethods
 * @param {function} params.clearSelectedProductInCart
 * @param {function} params.removeProductModal
 * @param {function} params.setIsInputFocused
 * @param {function} params.setShowInputFields
 * @param {function} params.setCustomMixItems
 * @param {function} params.setGroupQty
 * @param {function} params.setNotesPopup
 * @param {function} params.setNotesValue
 * @param {function} params.setSelectedProductForNotes
 * @param {function} params.setOpenSalesRep
 */
const getCartTableColumns = ({
  posConfig,
  cart,
  pricePrecision,
  currenciesList,
  selectedProductInCart,
  selectProductInCart,
  selectedRowKeys,
  setShowPaymentMethods,
  clearSelectedProductInCart,
  removeProductModal,
  setIsInputFocused,
  setShowInputFields,
  setCustomMixItems,
  setGroupQty,
  setNotesPopup,
  setNotesValue,
  setSelectedProductForNotes,
  setOpenSalesRep,
}) => [
  {
    title: "Item Name",
    dataIndex: "name",
    key: "name",
    width: "28%",
    render: (text, record) => {
      return (
        <>
          <div className="offerName" style={{ display: "flex", alignItems: "center" }}>
            {posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? (
              <>
                {record.salesRepName ? (
                  <>
                    <img src={userTieIcon} style={{ height: "2vh", marginRight: "5px", marginBottom: "2px" }} />
                    <span>{record.salesRepName}</span>
                  </>
                ) : (
                  cart.salesRepName && (
                    <>
                      <img src={userTieIcon} style={{ height: "2vh", marginRight: "5px", marginBottom: "2px" }} />
                      <span>{cart.salesRepName}</span>
                    </>
                  )
                )}
              </>
            ) : null}
          </div>

          <div
            onClick={() => {
              if (cart.type !== "Layaway") {
                selectProductInCart(record);
                selectedRowKeys.length > 0 && selectedProductInCart.productId === record.productId ? setShowPaymentMethods(false) : "";
              }
            }}
            id="sm-product-name"
            className="tableRow"
            style={{ textAlign: "left", marginLeft: 0 }}
          >
            {record.name}
          </div>

          <div className="offerName">
            <p style={{ margin: 0 }}>{record.cardNo ? record.cardNo : record.value}</p>
            {record.newCustomAttributes &&
              record.newCustomAttributes.length > 0 &&
              Object.entries(record.newCustomAttributes[0]).map(([key, value]) => {
                const display = customAttrDisplay(value);
                if (!display) return null;
                return (
                  <p key={key} style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>
                    {key} - {display}
                  </p>
                );
              })}

            {record.selectedAddons &&
              record.selectedAddons.length > 0 &&
              record.selectedAddons.map((item) => {
                return item?.name && <p style={{ margin: 0, padding: 0, color: "#8c92ac", fontStyle: "italic" }}>{item.name}</p>;
              })}

            <span
              style={{
                background: Math.abs(record.discount) > 0 ? "#F8C519" : "",
                padding: "0.25vw",
                display: record.discountName ? "" : "none",
              }}
            >
              {Math.abs(record.discount) > 0 ? record.discountName ? <img src={Offers} alt="" width={12} height={12} style={{ marginTop: "-2px" }} /> : "" : ""}{" "}
              {Math.abs(record.discount) > 0 ? record.discountName || "" : ""}{" "}
            </span>
          </div>
        </>
      );
    },
  },
  {
    title: "Qty",
    dataIndex: "weight",
    key: "weight",
    width: "11%",
    render: (text, record) => {
      const wt = parseFloat(text);
      if (Number.isInteger(wt)) {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div className="tableRow">{wt.toFixed(record.isQtyDesimal)}</div>
          </div>
        );
      } else {
        return (
          <>
            <div>{parseFloat(text).toFixed(record.isQtyDesimal)}</div>
            <div className="offerName">
              {record.salesRepName && posConfig?.showOrderSalesRep === "Y" && posConfig?.showLineSalesRep === "Y" ? record.salesRepName : ""}
            </div>
          </>
        );
      }
    },
    align: "center",
  },
  {
    title: "Discount",
    dataIndex: "discount",
    key: "discount",
    width: "11%",
    render: (text) => {
      return (
        <div>
          <span className="tableRow">{parseFloat(text).toFixed(pricePrecision)}</span>
        </div>
      );
    },
    align: "center",
  },
  {
    title: "Tax",
    dataIndex: "taxAmount",
    key: "taxAmount",
    width: "11%",
    render: (text) => {
      return (
        <div>
          <span className="tableRow">
            {text?.toFixed(pricePrecision).length < 8 ? parseFloat(text)?.toFixed(pricePrecision) : `${text?.toString().substring(0, 8)}`}
          </span>
        </div>
      );
    },
    align: "center",
  },
  {
    title: "Price",
    dataIndex: "realPrice",
    key: "realPrice",
    width: "10%",
    render: (text) => {
      return (
        <div>
          <span className="tableRow">{parseFloat(text).toFixed(pricePrecision)}</span>
        </div>
      );
    },
    align: "center",
  },
  {
    title: "Total",
    dataIndex: "nettotal",
    key: "nettotal",
    width: "15%",
    render: (text) => {
      return (
        <div style={{ position: "relative" }}>
          <span className="tableRow" style={{ width: "12%", left: "0" }}>
            {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
            &nbsp;
            {parseFloat(text).toFixed(pricePrecision)}
            &nbsp;
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
          </span>
        </div>
      );
    },
    align: "center",
  },
  {
    title: "",
    dataIndex: "",
    key: "",
    width: "10%",
    render: (text, record) => {
      if (record.groupedItems === true) return null;
      return (
        <div style={{ position: "relative", display: "flex", justifyContent: "space-evenly" }}>
          <img
            src={DeleteProduct}
            onClick={(e) => {
              e.stopPropagation();
              clearSelectedProductInCart();
              removeProductModal(record);
              setIsInputFocused(false);
              setShowInputFields(false);
              setCustomMixItems([]);
              setGroupQty(1);
            }}
            id="sm-product-delete"
            style={{
              height: "2.5vh",
              cursor: "pointer",
              right: 1,
              top: "15%",
            }}
          />
        {posConfig?.enableLineLevelNarration === "Y" && (
          <img
            onClick={(e) => {
              e.stopPropagation();
              clearSelectedProductInCart();
              setNotesPopup(true);
              setIsInputFocused(true);
              setNotesValue(record.notes);
              setSelectedProductForNotes(record);
              selectProductInCart(record);
              setIsInputFocused(false);
            }}
            src={NotesImage}
            alt=""
            style={{
              height: "14px",
              width: "14px",
              cursor: "pointer",
              paddingleft: "0.8vw",
            }}
          />
        )}
          {posConfig?.showLineSalesRep === "Y" && (
            <img
              src={userAddIcon}
              style={{ height: "2.3vh", cursor: "pointer", paddingTop: "1px" }}
              alt=""
              onClick={() => {
                setOpenSalesRep({ flag: true, level: "line" });
              }}
            />
          )}
        </div>
      );
    },
    align: "center",
  },
];

export default getCartTableColumns;
